import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

interface DayWeekContainerProps {
	onSelect?: (value: number) => void;
	value: number;
	isSelected: boolean;
	className?: string;
}

const DayWeekContainer = ({
	onSelect,
	value,
	isSelected,
	className = '',
}: DayWeekContainerProps) => {
	const labelMapUpper = {
		0: 'DOM',
		1: 'SEG',
		2: 'TER',
		3: 'QUA',
		4: 'QUI',
		5: 'SEX',
		6: 'SAB',
	} as const;

	const labelMapLower = {
		0: 'Dom',
		1: 'Seg',
		2: 'Ter',
		3: 'Qua',
		4: 'Qui',
		5: 'Sex',
		6: 'Sáb',
	} as const;

	return (
		<div
			className={cn(
				'relative flex h-[85px] min-w-[85px] flex-1 cursor-pointer select-none flex-col items-center justify-center rounded-2xl border transition-all duration-200',
				isSelected
					? 'border-stone-950 bg-stone-950 text-white shadow-lg shadow-stone-200' // Stone escuro
					: 'border-stone-100 bg-white text-stone-500 hover:border-stone-300 hover:shadow-sm', // Stone claro
				className,
			)}
			onClick={() => onSelect && onSelect(value)}
		>
			{/* Ícone Check no topo direito */}
			{isSelected && (
				<div className="absolute right-2 top-2">
					<Check className="size-3.5 text-white/90" strokeWidth={3} />
				</div>
			)}

			<span
				className={cn(
					'mb-1 text-[10px] font-bold uppercase tracking-widest',
					isSelected ? 'text-stone-400' : 'text-stone-400',
				)}
			>
				{labelMapUpper[value as keyof typeof labelMapUpper]}
			</span>
			<span
				className={cn(
					'text-lg font-bold',
					isSelected ? 'text-white' : 'text-stone-800',
				)}
			>
				{labelMapLower[value as keyof typeof labelMapLower]}
			</span>
		</div>
	);
};

export { DayWeekContainer };
